export default function dmsToDecimal(coordinateString: string): number {
  const direction = coordinateString.slice(-1); // Get the direction (N/S for latitude, E/W for longitude)
  const value = parseFloat(coordinateString.slice(0, -1)); // Remove the direction and parse the value
  const sign = direction === "N" || direction === "E" ? 1 : -1; // Determine the sign based on direction

  // Split the value into degrees, minutes, and seconds
  const degrees = Math.floor(value / 10000);
  const minutes = Math.floor((value - degrees * 10000) / 100);
  const seconds = value - degrees * 10000 - minutes * 100;

  // Convert to decimal degrees
  const decimalDegrees = sign * (degrees + minutes / 60 + seconds / 3600);
  return decimalDegrees;
}
